import { Navigate } from "react-router-dom";
import { JSX } from "react";
import { useAppSelector } from "../../app/hooks";
import {
  selectIsOrgOwnerOrAdmin,
  selectAuthInitializationStatus,
  selectIsAuthenticated,
} from "../../features/authentication/authenticationSlice";
import { ROUTES } from "../../routes";

/**
 * Gates organization Owner/Admin routes (billing, organization settings).
 * Waits for auth to hydrate, then redirects anyone unauthenticated to the
 * login page and plain-role Instructors to home. A token without the
 * organization-role claim belongs to a solo owner and passes. The server
 * independently enforces the role on every write.
 */
const RequireOrgAdmin = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isOrgOwnerOrAdmin = useAppSelector(selectIsOrgOwnerOrAdmin);
  const isInitialized = useAppSelector(selectAuthInitializationStatus);

  if (isInitialized !== "initialized") {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (!isOrgOwnerOrAdmin) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
};

export default RequireOrgAdmin;
